/** Helpers for soft-deleted organization access lockout and multi-org session state. */

import { DEVICE_STORAGE_PREFIX } from "pushNotifications/devicePushPreferences";

export function isOrganizationDeletedResponse(responseData) {
  if (!responseData) {
    return false;
  }
  return Boolean(responseData.organizationDeleted || responseData.userDetail?.organizationDeleted);
}

export function isUserOrganizationDeleted() {
  try {
    const raw = localStorage.getItem("userDetail");
    if (!raw) {
      return false;
    }
    const user = JSON.parse(raw);
    return Boolean(user?.organizationDeleted);
  } catch {
    return false;
  }
}

export function persistLoginSession(responseData, email, setToken) {
  localStorage.setItem("token", responseData?.token || "");
  if (email) {
    localStorage.setItem("userEmail", email);
  }

  if (responseData?.memberships) {
    localStorage.setItem("memberships", JSON.stringify(responseData.memberships));
  }

  if (responseData?.userDetail) {
    const detail = {
      ...responseData.userDetail,
      platformAdmin: responseData.platformAdmin ?? responseData.userDetail.platformAdmin ?? false,
      orgRole:
        responseData.orgRole ?? responseData.userDetail.orgRole ?? responseData.userDetail.type,
      activeOrgId: responseData.activeOrgId ?? responseData.userDetail.orgId,
      memberships: responseData.memberships ?? responseData.userDetail.memberships,
      platformPermissions: responseData.userDetail.platformPermissions || [],
    };
    localStorage.setItem("userDetail", JSON.stringify(detail));
    localStorage.setItem("permittedModules", JSON.stringify(detail?.permission || []));
    localStorage.setItem("platformPermissions", JSON.stringify(detail?.platformPermissions || []));
  }

  setToken?.(responseData?.token || "");
}

export function getStoredMemberships() {
  try {
    const fromDetail = JSON.parse(localStorage.getItem("userDetail"))?.memberships;
    if (Array.isArray(fromDetail) && fromDetail.length > 0) {
      return fromDetail;
    }
    const raw = localStorage.getItem("memberships");
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

/** Per-device choices (see devicePushPreferences) outlive the signed-in session. */
export function clearSession() {
  const deviceEntries = Object.keys(localStorage)
    .filter((key) => key.startsWith(DEVICE_STORAGE_PREFIX))
    .map((key) => [key, localStorage.getItem(key)]);
  localStorage.clear();
  deviceEntries.forEach(([key, value]) => localStorage.setItem(key, value));
  sessionStorage.clear();
}

export const ORG_DELETED_ERROR_CODE = "ORG_DELETED";

export const ORG_DELETED_MESSAGE = "Your organization has been deleted. Please contact support.";
